<template>
    <img
        :src="logo.url"
        :alt="logo.title"
        :aria-label="logo.title"
        :loading="lazy ? 'lazy' : 'eager'"
        :style="styleObj"
        @error="onError($event)"
    />
</template>

<script lang="ts" setup>
    import type {
        Logo
    } from '~/types';
    import { isNumber as lo_isNumber } from 'es-toolkit/compat';
    import type { StyleValue } from 'vue';

    const props = defineProps<{
        logo: Logo;
        fontSizePx?: number;
        lazy?: boolean;
    }>();

    const emit = defineEmits<{
        'on-error': [value: Event];
    }>();
    
    // TODO: This is a test but looks like it kinda works
    //       - Should be a config setting
    const fontScale = 1.45;
    const styleObj = ref<Undefinable<StyleValue>>();
    const { logo, fontSizePx } = props;

    const styles: StyleValue = {
        aspectRatio: logo.aspectRatio
    };

    if (lo_isNumber(fontSizePx)) {
        const size = Math.floor((fontSizePx / fontScale) * logo.scale);
        styles.height = `${size}px`;
    }

    styleObj.value = styles;

    function onError(e: Event): void {
        emit('on-error', e);
    }
</script>

<style lang="scss"></style>
